import { getDefinitionByName } from '@legacy-modules/common/util/kpiDefinitions';
import ValueExpression, {
  TargetValueType,
} from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';
import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';

export default new ValueExpression({
  identifier: 'dauervollmacht_quote',
  label: 'Dauervollmachtquote',
  definition: getDefinitionByName('Dauervollmachtquote'),
  positiveDirection: PositiveDirection.custom,
  valueQuotient: 0.01,
  valueFormat: '-#.###.##0,#0%',
  percent: true,
  targetValueType: TargetValueType.QUOTE,
  decimalPlaces: 2,
});
